import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'experience-engagements-tab-1-part',
	standalone: true,
	templateUrl: './experience-engagements-tab-1.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./experience-engagements-tab-1.part.scss`],
})
export class ExperienceEngagementsTab1Part {
}
